"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PodSession = void 0;
var foundation_1 = require("@deqo/foundation");
var __1 = require("..");
var PodSession = /** @class */ (function (_super) {
    __extends(PodSession, _super);
    function PodSession(pod, params) {
        var _this = _super.call(this) || this;
        _this.clientCache = new Map();
        _this.startSequence = [];
        _this.pod = pod;
        _this.params = params !== null && params !== void 0 ? params : {};
        _this.readonly = !!(params === null || params === void 0 ? void 0 : params.readonly);
        _this.router = new __1.EventRouter();
        _this.burden(pod.on('destroy', _this.destroy.bind(_this)));
        _this.pod.receive('notify_leave', function (_a) {
            var _b = __read(_a, 1), clientId = _b[0];
            return _this.releaseRef(clientId);
        });
        return _this;
    }
    PodSession.create = function (mix, pod, params) {
        return new mix(pod, params);
    };
    PodSession.prototype.getThisClient = function () {
        return this.createRef(this.pod.clientId);
    };
    PodSession.prototype.getPodId = function () {
        return this.pod.id;
    };
    PodSession.prototype.start = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, sr, mp, e_1_1;
            var e_1, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 5, 6, 7]);
                        _a = __values(this.startSequence), _b = _a.next();
                        _d.label = 1;
                    case 1:
                        if (!!_b.done) return [3 /*break*/, 4];
                        sr = _b.value;
                        mp = sr.call(this);
                        if (!mp) return [3 /*break*/, 3];
                        return [4 /*yield*/, mp];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3:
                        _b = _a.next();
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 7];
                    case 5:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 7];
                    case 6:
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    PodSession.prototype.destroy = function (reason) {
        if (this.destroyed())
            return;
        _super.prototype.destroy.call(this);
        this.pod.destroy(reason !== null && reason !== void 0 ? reason : 'unknown');
        this.router.emit('destroy', reason);
        this.router.destroy();
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    PodSession.prototype.on = function (type, to) {
        return this.router.on(type, to);
    };
    PodSession.prototype.onInit = function (startRoutine) {
        this.startSequence.push(startRoutine);
    };
    PodSession.prototype.createRef = function (clientId) {
        var ref = this.clientCache.get(clientId);
        if (!ref) {
            var _a = __read(clientId.split('/'), 2), userId = _a[0], instanceId = _a[1];
            ref = Object.freeze({ id: clientId, userId: userId, instanceId: instanceId });
            this.clientCache.set(clientId, ref);
        }
        return ref;
    };
    PodSession.prototype.releaseRef = function (clientId) {
        this.clientCache.delete(clientId);
    };
    __decorate([
        (0, foundation_1.memone)()
    ], PodSession.prototype, "getThisClient", null);
    return PodSession;
}(foundation_1.AbstractDestroyable));
exports.PodSession = PodSession;
